import { SVG, SVGProps } from './svg'

export function IconInterval(props: SVGProps) {
  return (
    <SVG {...props} viewBox="0 0 24 24">
      <path d="M5 15v-3.5c0-.3-.2-.5-.5-.5h-1c-.3 0-.5.2-.5.5V15c0 1.1.9 2 2 2h14a2 2 0 002-2v-3.5c0-.3-.2-.5-.5-.5h-1c-.3 0-.5.2-.5.5V15H5z" />
    </SVG>
  )
}
